import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CategoryClient } from './category-client.service';
import { UserClient } from './user-client.service';
import { ProviderClient } from './provider-client.service';
import { SettingClient } from './setting-client.service';
import { SupportClient } from './support-client.service';
import { FaqClient } from './faq-client.service';
import {DashboardClient} from './dashboard-client.service';
import { EventClient } from './event-client.service';
import { OfferClient } from './offer-client.service';
import { AdminConfigClient } from './adminconfig-client.service';

const SERVICES = [
  AdminConfigClient,
  CategoryClient,
  UserClient,
  ProviderClient,
  SettingClient,
  SupportClient,
  FaqClient,
  DashboardClient,
  EventClient,
  OfferClient
];

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    ...SERVICES,
  ],
})
export class NetworkModule {
  static forRoot(): ModuleWithProviders<NetworkModule> {
    return <ModuleWithProviders<NetworkModule>>{
      ngModule: NetworkModule,
      providers: [
        ...SERVICES,
      ],
    };
  }
}
